import {Icon as Iconify} from '@iconify/react';
import type {Overrides} from 'helpers/overrides';
import type {StyleProp, ViewStyle} from 'react-native';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  opacity?: number;
  overrides?: Overrides<ViewStyle | StyleProp<ViewStyle>>;
}

export function Icon({name, size = 18, color, opacity, overrides}: IconProps) {
  return (
    <Iconify
      icon={name}
      width={size}
      height={size}
      color={color}
      style={{
        opacity,
        ...(overrides || {}),
      }}
    />
  );
}
